<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="tabela && !loading">
      <div>
        <b-table
          responsive="sm"
          :items="dadosAcademicos"
          :fields="camposAcademicos"
          per-page="1000"
          striped
        >
          <template #cell(options)="data">
            <div class="d-flex justify-content-end">
              <b-button
                size="sm"
                class="me-1"
                variant="primary"
                @click="editarDadosAcademicos(data.item)"
                data-tooltip="Editar"
                data-tooltip-location="left"
              >
                <i class="mdi mdi-pencil"></i>
              </b-button>
              <b-button
                size="sm"
                class="me-1"
                variant="danger"
                @click="excluirDadosAcademicos(data.item)"
                data-tooltip="Excluir"
                data-tooltip-location="left"
              >
                <i class="mdi mdi-trash-can"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div>
        <div class="mt-1 d-flex justify-content-end">
          <b-button variant="info" class="mt-5 mb-3" @click="incluir()">
            <i class="mdi mdi-plus"></i>
            Incluir
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
            class="mt-1 me-1"
            @click="navegar('redesSociais', false)"
            data-tooltip="Voltar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            variant="primary"
            class="mt-1"
            @click="navegar('ExpProfissional', true)"
            data-tooltip="Próximo"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-right-circle font-size-15"></i>
          </b-button>
        </div>
      </div>
    </div>

    <div v-if="!tabela && !loading">
      <div class="row">
        <div class="col-md-9">
          <b-form-group class="mb-3" label="Curso Acadêmico">
            <multiselect
              v-model="selectCurso"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="nm_curso"
              :options="optionCurso"
              :disabled="addCurso"
            />
          </b-form-group>
        </div>
        <div class="col-md-3 d-flex flex-column">
          <b-form-group label="Não achou seu curso?"> </b-form-group>
          <b-button style="width: 100%" @click="addLookUp('curso')">
            Adicionar Curso
          </b-button>
        </div>
      </div>
      <div class="row" v-if="addCurso">
        <div class="col-md-12">
          <b-form-group
            class="mb-3"
            label="Escreva um novo curso acadêmico abaixo:"
          >
            <b-form-input
              :disabled="!addCurso"
              v-model="cursoDigitado"
              type="text"
              autocomplete="off"
              maxlength="80"
              trim
            ></b-form-input>
            <div class="text-center">
              <p
                v-if="cursoDigitado"
                class="badge position-absolute"
                :class="{
                  'bg-success': cursoDigitado.length !== 80,
                  'bg-danger': cursoDigitado.length === 80,
                }"
              >
                {{ cursoDigitado.length }} / 80
              </p>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <b-form-group class="mb-3" label="Instituição de Ensino">
            <multiselect
              v-model="selectInstituicaoEnsino"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="nm_instituicao"
              :options="optionInstituicao"
              :disabled="addInstituicao"
            />
          </b-form-group>
        </div>
        <div class="col-md-3 d-flex flex-column">
          <b-form-group label="Não achou a instituição?"> </b-form-group>
          <b-button style="width: 100%" @click="addLookUp('instituicao')">
            Adicionar Instituição
          </b-button>
        </div>
      </div>
      <div class="row" v-if="addInstituicao">
        <div class="col-md-9">
          <b-form-group
            class="mb-3"
            label="Escreva uma nova instituição abaixo:"
          >
            <b-form-input
              :disabled="!addInstituicao"
              v-model="institDigitado"
              type="text"
              autocomplete="off"
              maxlength="80"
              trim
            ></b-form-input>
            <div class="text-center">
              <p
                v-if="institDigitado"
                class="badge position-absolute"
                :class="{
                  'bg-success': institDigitado.length !== 80,
                  'bg-danger': institDigitado.length === 80,
                }"
              >
                {{ institDigitado.length }} / 80
              </p>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label="Âmbito da Instituição">
            <multiselect
              v-model="selectAmbito"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="ds_ambito"
              :options="optionAmbito"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-form-group class="mb-3" label="Nível de Formação">
            <multiselect
              v-model="selectFormacao"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="FORMACAO"
              :options="optionFormacao"
            />
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label="Situação">
            <multiselect
              v-model="selectSituacao"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="STATUSFORMACAO"
              :options="optionSituacao"
            />
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group class="mb-3" label="Ano Início">
            <date-picker
              v-model="dados.NRANOINICIAL"
              value-type="YYYY"
              type="year"
              :disabled-date="dataMenorNascimento()"
              @keyup="disabledData()"
              append-to-body
              :editable="false"
            />
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group
            class="mb-3"
            label="Ano Conclusão"
            v-if="selectSituacao && selectSituacao.STFORMACAO === 'P'"
          >
            <date-picker
              v-model="dados.NRANOCONCLUSAO"
              value-type="YYYY"
              type="year"
              :disabled-date="disabledData()"
              append-to-body
              :editable="false"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div>
          <b-form-checkbox
            id="principal"
            v-model="cursoPrincipal"
            name="principal"
            value="S"
            unchecked-value="N"
            plain
            :disabled="principal == 'S'"
          >
            Curso Principal
          </b-form-checkbox>
        </div>
        <div class="mt-1 d-flex justify-content-between">
          <b-button
            class="mt-1 me-1"
            variant="secondary"
            @click="tabela = !tabela"
            data-tooltip="voltar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            variant="success"
            class="mt-1"
            @click="salvarDadosAcademicos()"
            data-tooltip="Salvar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-content-save"></i>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

export default {
  components: {
    Multiselect,
  },
  async created() {
    this.disabledData();
    this.buscarTabelaDadosAcademicos();
    await this.preencheLookup();
  },
  data() {
    return {
      tabela: true,
      dadosAcademicos: [],
      camposAcademicos: [
        {
          key: "NMINSTITUICAO",
          label: "Instituição",
          formatter: (value) => {
            return capitalizeString(value);
          },
        },
        {
          key: "NMCURSO",
          label: "Curso",
          formatter: (value) => {
            return capitalizeString(value);
          },
        },
        {
          key: "STATUSFORMACAO",
          label: "Situação",
        },
        {
          key: "PRINCIPAL",
          label: "Principal",
        },
        {
          key: "options",
          label: "",
        },
      ],
      dados: {
        NRANOINICIAL: "",
        NRANOCONCLUSAO: "",
      },
      optionCurso: [],
      optionInstituicao: [],
      optionAmbito: [],
      optionFormacao: [
        {
          TPFORMACAO: "D",
          FORMACAO: "Doutorado",
        },
        {
          TPFORMACAO: "E",
          FORMACAO: "Especialização",
        },
        {
          TPFORMACAO: "M",
          FORMACAO: "Mestrado",
        },
        {
          TPFORMACAO: "S",
          FORMACAO: "Superior",
        },
        {
          TPFORMACAO: "T",
          FORMACAO: "Técnico",
        },
      ],
      optionSituacao: [
        {
          STFORMACAO: "C",
          STATUSFORMACAO: "Cursando",
        },
        {
          STFORMACAO: "I",
          STATUSFORMACAO: "Interrompido",
        },
        {
          STFORMACAO: "P",
          STATUSFORMACAO: "Completo",
        },
      ],
      loading: true,
      selectCurso: {},
      selectInstituicaoEnsino: {},
      selectFormacao: {},
      selectSituacao: {},
      selectAmbito: {},
      sqFormacao: 0,
      addCurso: false,
      cursoDigitado: "",
      addInstituicao: false,
      institDigitado: "",
      principal: "",
      cursoPrincipal: "",
      dataNascimento: "",
    };
  },
  methods: {
    isPrincipal(valor) {
      if (typeof valor === "boolean") return valor;
      if (valor === null || valor === undefined) return false;
      const valorNormalizado = String(valor).trim().toUpperCase();
      return ["S", "SIM", "TRUE", "1"].includes(valorNormalizado);
    },

    dataMenorNascimento() {
      if (this.dataNascimento) {
        var dataInicio = this.dataNascimento.replace(/[-]/g, " ").split(" ");
        return (date) => date < new Date(dataInicio[0]);
      }
      return () => null;
    },
    disabledData() {
      if (this.dados.NRANOINICIAL) {
        var dataInicio = this.dados.NRANOINICIAL.replace(/[-]/g, " ").split(
          " "
        );
        return (date) => date < new Date(dataInicio[0]);
      }
      return () => null;
    },
    buscarTabelaDadosAcademicos() {
      this.loading = true;
      this.$http
        .get("api/profileErp/formacoes")
        .then((response) => {
          this.dadosAcademicos = (response.data || []).map((item) => {
            const principalRegistro = this.isPrincipal(item.STPRINCIPAL)
              || this.isPrincipal(item.stPrincipal)
              || this.isPrincipal(item.st_principal)
              || this.isPrincipal(item.Principal)
              || this.isPrincipal(item.principal)
              || this.isPrincipal(item.PRINCIPAL);

            return {
              ...item,
              NMINSTITUICAO: item.NMINSTITUICAO || item.nmInstituicao || item.instituicao || item.Instituicao || item.InstituicaoEnsino?.Descricao || item.DescricaoInstituicaoEnsino || "",
              NMCURSO: item.NMCURSO || item.nmCurso || item.curso || item.Curso || item.Formacao?.Descricao || item.DescricaoFormacao || "",
              STATUSFORMACAO: item.STATUSFORMACAO || (item.Situacao === "C" ? "Cursando" : item.Situacao === "I" ? "Interrompido" : item.Situacao === "P" ? "Completo" : (item.situacao === "C" ? "Cursando" : item.situacao === "I" ? "Interrompido" : "Completo")),
              PRINCIPAL: principalRegistro ? "Sim" : "Não",
              STPRINCIPAL: principalRegistro ? "S" : "N",
              principal: principalRegistro,
              Principal: principalRegistro,
              SQFORMACAO: item.SQFORMACAO || item.sqFormacao || item.id || item.Id || "",
              CDCURSO: item.CDCURSO || item.cdCurso || item.idCurso || item.IdFormacao || "",
              CDINSTITUICAO: item.CDINSTITUICAO || item.cdInstituicao || item.idInstituicao || item.IdInstituicaoEnsino || "",
              TPFORMACAO: item.TPFORMACAO || item.tpFormacao || item.nivelFormacao || item.IdNivelFormacao || "",
              STFORMACAO: item.STFORMACAO || item.stFormacao || item.Situacao || item.situacao || "",
              NRANOINICIAL: item.NRANOINICIAL || item.nrAnoInicial || item.AnoInicio || item.anoInicio || "",
              NRANOCONCLUSAO: item.NRANOCONCLUSAO || item.nrAnoConclusao || item.AnoConclusao || item.anoConclusao || ""
            };
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async preencheLookup() {
      await Promise.all([
        this.$http.get("api/profileErp/catalogo-formacoes").catch(() => ({ data: [] })),
        this.$http.get("api/profileErp/instituicoes-ensino").catch(() => ({ data: [] })),
        this.$http.get("api/cadastroCandidato/buscarAmbitos"),
        this.$http.get("api/profileErp/niveis-formacao").catch(() => ({ data: [] }))
      ]).then(([responseCurso, responseInstituicao, responseAmbito, responseNivel]) => {
        this.optionCurso = (responseCurso.data || []).map((item) => {
          return { ...item, nm_curso: capitalizeString(item.Descricao || item.descricao || item.Nome || item.nome || ""), cd_curso: item.Id || item.id };
        });
        this.optionInstituicao = (responseInstituicao.data || []).map((item) => {
          return {
            ...item,
            nm_instituicao: capitalizeString(item.Descricao || item.descricao || item.NomeFantasia || item.nomefantasia || item.Nome || item.nome || ""),
            cd_instituicao: item.Id || item.id
          };
        });
        this.optionAmbito = responseAmbito.data;
        
        const niveisErp = responseNivel.data || [];
        if (Array.isArray(niveisErp) && niveisErp.length > 0) {
          this.optionFormacao = niveisErp.map((item) => ({
            ...item,
            Id: parseInt(item.Id || item.id),
            id: parseInt(item.Id || item.id),
            FORMACAO: item.Descricao || item.descricao || item.Nome || item.nome || "",
            TPFORMACAO: item.Sigla || item.sigla || item.Id || item.id
          }));
        }
      });
      return true;
    },
    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },
    async salvarDadosAcademicos() {
      if (
        parseInt(this.dados.NRANOINICIAL) > parseInt(this.dados.NRANOCONCLUSAO)
      ) {
        this.$tools.alerta("Ano Início maior que Ano Conclusão", "warning");
        return;
      }

      if (
        (!this.selectCurso && !this.addCurso) ||
        (!this.selectCurso && this.addCurso && this.cursoDigitado == "") ||
        (!this.selectInstituicaoEnsino && !this.addInstituicao) ||
        (!this.selectInstituicaoEnsino &&
          this.addInstituicao &&
          (this.institDigitado == "" || !this.selectAmbito)) ||
        !this.selectFormacao ||
        !this.selectSituacao ||
        !this.dados.NRANOINICIAL ||
        (this.selectSituacao.STFORMACAO === "P" && !this.dados.NRANOCONCLUSAO)
      ) {
        this.$tools.alerta(
          "Não foi possível cadastrar os dados acadêmicos",
          "error"
        );
        return;
      }
      if (
        (this.dados.NRANOINICIAL < this.dataNascimento ||
          this.dados.anoConclusao < this.dataNascimento) &&
        this.dataNascimento != null
      ) {
        this.$tools.alerta(
          "Favor verifique as datas de inicio e conclusão do curso",
          "warning"
        );
        return;
      }
      this.enviarParaBanco();
    },
    enviarParaBanco() {
      var item = {};
      if (this.addCurso) {
        item.nmCurso = this.cursoDigitado;
        item.tp_curso = this.selectFormacao.TPFORMACAO;
        item.cd_curso = "";
        
        item.CursoDigitado = this.cursoDigitado;
        item.cursoDigitado = this.cursoDigitado;
      } else {
        item.tp_curso = this.selectFormacao.TPFORMACAO;
        item.cd_curso = this.selectCurso.cd_curso;
        
        item.IdCurso = this.selectCurso.cd_curso || this.selectCurso.id;
        item.idCurso = this.selectCurso.cd_curso || this.selectCurso.id;
      }

      if (this.addInstituicao) {
        item.nmInstituicao = this.institDigitado;
        item.sqGeAmbito = this.selectAmbito.sq_ge_ambito;
        item.cd_instituicao = "";
        
        item.InstituicaoDigitada = this.institDigitado;
        item.instituicaoDigitada = this.institDigitado;
        item.IdAmbito = this.selectAmbito?.sq_ge_ambito || this.selectAmbito?.id;
        item.idAmbito = this.selectAmbito?.sq_ge_ambito || this.selectAmbito?.id;
      } else {
        item.cd_instituicao = this.selectInstituicaoEnsino?.cd_instituicao;
        item.IdInstituicao = this.selectInstituicaoEnsino?.cd_instituicao || this.selectInstituicaoEnsino?.id;
        item.idInstituicao = this.selectInstituicaoEnsino?.cd_instituicao || this.selectInstituicaoEnsino?.id;
      }

      item.nivelFormacao = this.selectFormacao?.TPFORMACAO;
      item.situacao = this.selectSituacao?.STFORMACAO;
      item.anoInicio = this.dados.NRANOINICIAL;
      item.anoConclusao = this.dados.NRANOCONCLUSAO;
      item.sqFormacao = this.sqFormacao;
      item.principal = this.cursoPrincipal === "S" ? true : false;
      
      const anoInicioSanitizado = this.dados.NRANOINICIAL ? this.dados.NRANOINICIAL.toString().slice(0, 4) : null;
      const anoConclusaoSanitizado = (this.selectSituacao?.STFORMACAO === "C" || this.selectSituacao?.STFORMACAO === "cursando")
        ? null
        : (this.dados.NRANOCONCLUSAO ? this.dados.NRANOCONCLUSAO.toString().slice(0, 4) : null);

      let payload = {
        Id: this.sqFormacao || null,
        AnoInicio: anoInicioSanitizado,
        AnoConclusao: anoConclusaoSanitizado,
        Principal: this.cursoPrincipal === "S" ? "S" : "N",
        Situacao: this.selectSituacao?.STFORMACAO || "P",
        
        // Novos campos mapeados para o portal_api (novo ERP)
        IdNivelFormacao: parseInt(this.selectFormacao?.Id || this.selectFormacao?.id || 1),
        IdFormacao: this.addCurso ? null : (parseInt(this.selectCurso?.Id || this.selectCurso?.id || this.selectCurso?.cd_curso || 0) || null),
        IdInstituicaoEnsino: this.addInstituicao ? null : (parseInt(this.selectInstituicaoEnsino?.Id || this.selectInstituicaoEnsino?.id || this.selectInstituicaoEnsino?.cd_instituicao || 0) || null),
      };

      if (this.addCurso) {
        payload.DescricaoFormacao = this.cursoDigitado;
      }
      if (this.addInstituicao) {
        payload.DescricaoInstituicaoEnsino = this.institDigitado;
      }

      this.loading = true;
      const isEdit = !!this.sqFormacao;
      const url = isEdit ? `api/profileErp/formacoes/${this.sqFormacao}` : "api/profileErp/formacoes";
      const requestAction = isEdit ? this.$http.put(url, payload) : this.$http.post(url, payload);

      requestAction
        .then(() => {
          this.tabela = true;
          this.loading = false;
          this.$tools.alerta("Cadastrado com sucesso", "success");
          this.buscarTabelaDadosAcademicos();
          this.preencheLookup();
        })
        .catch((err) => {
          this.loading = false;
          this.$tools.alerta(err.response?.data?.message || "Não foi possível cadastrar os dados acadêmicos no ERP", "error");
        });
      this.$emit("carregarNivelPerfil", true);
    },
    excluirDadosAcademicos(val) {
      if (this.isPrincipal(val.STPRINCIPAL) || this.isPrincipal(val.PRINCIPAL) || this.isPrincipal(val.Principal) || this.isPrincipal(val.principal)) {
        this.$tools.alerta(
          "Não é possível excluir um registro principal",
          "warning"
        );
        return;
      }
      this.loading = true;
      this.$http
        .delete("api/profileErp/formacoes/" + val.SQFORMACAO)
        .then(() => {
          this.tabela = true;
          this.loading = false;
          this.buscarTabelaDadosAcademicos();
        })
        .catch((err) => {
          this.loading = false;
          this.$tools.alerta(err.response?.data?.message || "Erro ao excluir formação no ERP", "error");
        });
      this.$emit("carregarNivelPerfil", true);
    },
    async editarDadosAcademicos(item) {
      this.loading = true;
      if (this.optionCurso.length == 0) {
        await this.preencheLookup();
      }
      this.dados = item;
      const principalNormalizado = this.isPrincipal(item.STPRINCIPAL)
        || this.isPrincipal(item.PRINCIPAL)
        || this.isPrincipal(item.Principal)
        || this.isPrincipal(item.principal)
        ? "S"
        : "N";
      this.principal = principalNormalizado;
      this.cursoPrincipal = principalNormalizado;
      this.selectCurso = this.optionCurso.find(
        (el) => el.cd_curso == this.dados.CDCURSO
      );
      this.selectInstituicaoEnsino = this.optionInstituicao.find(
        (el) => el.cd_instituicao == this.dados.CDINSTITUICAO
      );
      this.selectFormacao = this.optionFormacao.find(
        (el) => el.TPFORMACAO == this.dados.TPFORMACAO || el.Id == this.dados.TPFORMACAO || el.id == this.dados.TPFORMACAO
      );
      this.selectSituacao = this.optionSituacao.find(
        (el) => el.STFORMACAO == this.dados.STFORMACAO
      );
      this.sqFormacao = this.dados.SQFORMACAO;
      this.loading = false;
      this.addCurso = false;
      this.addInstituicao = false;
      this.tabela = !this.tabela;
    },
    incluir() {
      this.dados.NRANOINICIAL = "";
      this.dados.NRANOCONCLUSAO = "";
      this.selectCurso = "";
      this.selectInstituicaoEnsino = "";
      this.selectFormacao = "";
      this.selectSituacao = "";
      this.sqFormacao = "";
      this.selectAmbito = "";
      this.cursoDigitado = "";
      this.institDigitado = "";
      this.addCurso = false;
      this.addInstituicao = false;
      if (this.dadosAcademicos.length == 0) {
        this.cursoPrincipal = "S";
        this.principal = "S";
      } else {
        this.principal = "";
        this.cursoPrincipal = "N";
      }
      this.$http
        .get("api/profileErp/dados-pessoais")
        .then((response) => {
          const raw = response.data || {};
          this.dataNascimento = raw.DT_NASC || raw.dtNasc || raw.DtNasc || raw.dataNascimento || raw.DataNascimento || "";
          this.dataMenorNascimento();
          this.tabela = !this.tabela;
        });
    },
    addLookUp(nome) {
      switch (nome) {
        case "curso":
          this.addCurso = !this.addCurso;
          this.selectCurso = "";
          this.cursoDigitado = "";
          break;
        case "instituicao":
          this.addInstituicao = !this.addInstituicao;
          this.selectInstituicaoEnsino = "";
          this.institDigitado = "";
          this.selectAmbito = "";
          break;
      }
    },
  },
};
</script>